<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 pa-4">
        <v-row>
          <v-col>
            <h2>รายงานแจกคะแนนวันเกิด</h2>
          </v-col>
          <v-col
            class="text-right mb-4"
            v-if="session.data.userTypeGroup !== 'Operation'"
          >
            <v-btn
              class="btn-color"
              v-on="on"
              outlined
              color="indigo"
            >
              <download-excel
                class="btn btn-default text-white"
                :data="tab === 0 ? dataItem : dataItem2"
                :fields="export_fields"
                :type="exportType"
                :worksheet="exportWorksheet"
                :name="exportFileName"
                style="display: flex"
              >
                <v-icon color="indigo">
                  mdi-download
                </v-icon>
                <p class="mb-0 indigo--text">Export Data</p>
              </download-excel>
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="pb-3 mt-5 ma-0 w-100 col-grid">
          <div class="pa-0">
            <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    label="ค้นหาตามวันที่"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="clearTextField()"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
          </div>
          <div class="pa-0">
            <v-text-field
              v-model="memberSearch"
              label="ค้นหา ชื่อ / เบอร์โทร"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
              hide-details
            ></v-text-field>
          </div>
          <v-btn class="btn-grid" color="indigo" dark @click.stop="getData()">ค้นหา</v-btn>
        </v-row>

        <v-card>
          <v-tabs v-model="tab" color="#1b437c">
              <v-tab>
                <h4>รับคะแนนแล้ว</h4>
              </v-tab>
              <v-tab>
                <h4>ยังไม่รับคะแนน</h4>
              </v-tab>
            </v-tabs>
          <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-data-table
                  :headers="columnsGet"
                  :items="dataItem"
                  :search="memberSearch"
                  :custom-filter="memberFilter"
                  :items-per-page="10"
                  class="elevation-1"
                  style="padding-top: 10px"
                >
                  <!-- <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.packagePrice`]="{ item }">
                    {{ formatNumber(item.packagePrice) }}
                  </template> -->
                  <template v-slot:[`item.status`]="{ item }">
                    <v-chip
                      dark
                      color="green"
                    >รับคะแนนแล้ว</v-chip>
                  </template>
                  <template v-slot:[`item.picture`]="{ item }">
                    <v-avatar color="primary" size="40">
                      <img :src="item.picture" alt="img"
                    /></v-avatar>
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                  <div>{{ thaiFormattedDateHHmm(item.LAST_DATE) }}</div>
                 </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-data-table
                  :headers="columnsOpen"
                  :items="dataItem2"
                  :search="memberSearch"
                  :custom-filter="memberFilter"
                  :items-per-page="10"
                  class="elevation-1"
                  style="padding-top: 10px"
                >
                  <template v-slot:[`item.status`]="{ item }">
                    <v-chip
                      dark
                      color="red"
                    >ยังไม่รับคะแนน</v-chip>
                  </template>
                  <template v-slot:[`item.picture`]="{ item }">
                    <v-avatar color="primary" size="40">
                      <img :src="item.picture" alt="img"
                    /></v-avatar>
                  </template>
                </v-data-table>
              </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx'
import memberSearch from '@/mixins/memberSearch'
export default {
  mixins: [memberSearch],
  components: {
    moment,
    downloadExcel: JsonExcel,
    XLSX
  },
  data () {
    return {
      PK: '',
      returnLink: '/Master/Package',
      session: this.$session.getAll(),
      tab: null,
      dialogPackageMember: false,
      valid: true,
      columnsGet: [
        { text: 'รูป', value: 'picture' },
        { text: 'ชื่อไลน์', value: 'name' },
        { text: 'ชื่อลูกค้า', value: 'nameCustomer' },
        { text: 'วันเกิด', value: 'birthDate' },
        { text: 'ปี', value: 'year' },
        { text: 'คะแนน', value: 'point' },
        { text: 'วันที่ได้คะแนน', value: 'LAST_DATE' },
        { text: 'สถานะ', value: 'status' }
        // { text: 'คะแนนที่ได้ต่อครั้ง', value: 'packagePoint', align: 'center' },
        // { text: 'รายละเอียด', value: 'packageDetail' },
        // { text: 'อายุการใช้งาน', value: 'packageExpridate', align: 'center' }
      ],
      itemExpri: [
        { text: '3 เดือน', value: '3' },
        { text: '6 เดือน', value: '6' },
        { text: '9 เดือน', value: '9' },
        { text: '1 ปี', value: '12' }
      ],
      columnsOpen: [
        { text: 'รูป', value: 'picture' },
        { text: 'ชื่อไลน์', value: 'name' },
        { text: 'ชื่อลูกค้า', value: 'nameCustomer' },
        { text: 'วันเกิด', value: 'birthDate' },
        { text: 'ปี', value: 'year' },
        { text: 'คะแนน', value: 'point' },
        { text: 'สถานะ', value: 'status' }
      ],
      export_fields: {
        ไลน์ยูสเซอร์ไอดี: 'lineUserId',
        'เบอร์โทร': {
          field: 'tel',
          callback: (value) => {
            const telString = value.toString()
            return telString.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
          },
          formatNumber: '@'
        },
        ชื่อไลน์: 'name',
        ชื่อลูกค้า: 'nameCustomer',
        วันเกิด: 'birthDate',
        ปี: 'year',
        คะแนน: 'point',
        สถานะ: 'status',
        'วันที่ได้คะแนน': {
          field: 'LAST_DATE',
          callback: (value) => {
            const formattedValue = value
              ? moment.utc(new Date(value)).format('DD/MM/YYYY HH:mm:ss').toString()
              : null
            if (formattedValue) {
              return moment.utc(formattedValue, 'DD/MM/YYYY HH:mm:ss').add(543, 'years').format('DD/MM/YYYY HH:mm:ss')
            } else {
              return ''
            }
          }
        }
      },
      exportFileName: '',
      dataItem: [],
      dataItem2: [],
      on: {},
      exportType: 'application/vnd.ms-excel',
      exportWorksheet: 'Sheet1',
      date: [],
      menu: false,
      startDate: '',
      endDate: ''
    }
  },
  async mounted () {
    // await this.getDataGlobal(
    //   this.DNS_IP,
    //   this.path,
    //   this.session.data.shopId,
    //   this.returnLink
    // )
    this.generateFileName()
    await this.getDataLogMembeGet()
    await this.getDataLogMemberOpen()
  },
  computed: {
    dateRangeText: {
      get () {
        return this.date.join(' - ')
      },
      set (value) {
        this.date = value ? value.split(' - ') : []
      }
    }
  },
  methods: {
    generateFileName () {
      const date = moment().format('DDMMYYYY')
      this.exportFileName = ` Report_Birthday_${date}.xls`
    },
    async getDataLogMemberOpen () {
      try {
        this.dataItem = []
        await this.setDate()

        let url = this.DNS_IP + '/Log_Birthday/get?shopId=' + this.session.data.shopId + '&status=get'

        if (this.startDate && this.endDate) {
          url += `&CREATE_DATE=${encodeURIComponent(`${this.startDate},${this.endDate}`)}`
        }

        await axios
          .get(
            url
          )
          .then(res => {
            if (res.data.status !== false) {
              this.dataItem = res.data
              console.log('res.data', res.data)
              this.dataItem.map((item) => {
                item.status = 'รับคะแนนแล้ว'
                item.birthDate = moment(item.birthDate.split('-').toReversed().join('-'), 'DD-MM').lang('th').format('D MMM')
              })
            } else {
              this.dataItem = []
            }
          })
      } catch (error) {
        console.log('error', error)
      }
    },
    async getDataLogMembeGet () {
      this.dataItem2 = []
      await this.setDate()

      let url = this.DNS_IP + '/Log_Birthday/get?shopId=' + this.session.data.shopId + '&status=open'

      if (this.startDate && this.endDate) {
        url += `&CREATE_DATE=${encodeURIComponent(`${this.startDate},${this.endDate}`)}`
      }
      await axios
        .get(
          url
        )
        .then(res => {
          if (res.data.status !== false) {
            this.dataItem2 = res.data
            this.dataItem2.map((item) => {
              item.status = 'ยังไม่รับคะแนน'
              item.birthDate = moment(item.birthDate.split('-').toReversed().join('-'), 'DD-MM').lang('th').format('D MMM')
            })
          } else {
            this.dataItem2 = []
          }
        })
    },
    setDate () {
      this.startDate = ''
      this.endDate = ''
      if (this.date.length === 2) {
        this.date.sort()
        this.startDate = moment(this.date[0]).format('YYYY-MM-DD')
        this.endDate = moment(this.date[1]).format('YYYY-MM-DD')
      } else if (this.date.length === 1) {
        this.startDate = moment(this.date[0]).format('YYYY-MM-DD')
        this.endDate = moment(this.date[0]).format('YYYY-MM-DD')
      }
    },
    async getData () {
      await this.getDataLogMembeGet()
      await this.getDataLogMemberOpen()
    },
    clearTextField () {
      this.date = []
      this.getData()
    }
  }
}
</script>
<style scoped>
h3 {
  font-size: 18.72px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/reportBirtdayPoint.vue